import React from 'react'

function ManageUser({userData}) {
  return <div>Manage User: Coming Soon</div>
}

export default ManageUser
